import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Circle, X, Rocket } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STEPS = [
  ["company", "Firma bilgilerini tamamlayın", "Ad, telefon ve e-posta faturalarda ve e-postalarda görünür.", "/ayarlar"],
  ["accounts", "İlk cari hesabı ekleyin", "Müşteri veya tedarikçinizi kaydedin; Excel'den toplu aktarabilirsiniz.", "/cariler"],
  ["products", "Ürün / hizmet tanımlayın", "Stok takibi ve fatura kalemleri için.", "/urunler"],
  ["invoices", "İlk faturayı kesin", "Satış veya alış faturası; fiş fotoğrafından da oluşturabilirsiniz.", "/faturalar/yeni"],
  ["payments", "Tahsilat / ödeme girin", "Kasa ve cari bakiyeleri anında güncellenir.", "/kasa"],
  ["team", "Ekip arkadaşınızı davet edin", "Rol ve yetkilerle güvenli paylaşım.", "/ayarlar"],
];

export default function SetupWizard() {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/setup/status").then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st || st.dismissed) return null;
  const done = STEPS.filter(([k]) => st[k]).length;
  if (done === STEPS.length) return null;
  const dismiss = async () => { await api.post("/setup/dismiss").catch(() => {}); setSt({ ...st, dismissed: true }); };
  return (
    <div className="fade-up relative mb-6 border border-[#2dd4bf]/40 bg-gradient-to-r from-teal-50 via-white to-orange-50 p-5" data-testid="setup-wizard">
      {user?.role !== "user" && <button type="button" onClick={dismiss} className="absolute right-3 top-3 text-slate-400 hover:text-slate-700" aria-label="Kapat" data-testid="setup-dismiss-button"><X /></button>}
      <div className="flex flex-wrap items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-zinc-950 text-[#fdba74]"><Rocket weight="fill" /></span>
        <div>
          <h3 className="font-display text-lg font-bold">Hızlı Başlangıç · {done}/{STEPS.length} tamamlandı</h3>
          <p className="text-xs text-slate-600">Birkaç dakikada sistemi kullanıma hazır hale getirin. <Link to="/rehber" className="font-semibold text-teal-700 hover:underline" data-testid="setup-guide-link">Nasıl yapılır? rehberi →</Link></p>
        </div>
        <div className="ml-auto h-2 w-40 overflow-hidden rounded-full bg-slate-200"><div className="h-full bg-[#2dd4bf] transition-all" style={{ width: `${(done / STEPS.length) * 100}%` }} data-testid="setup-progress" /></div>
      </div>
      <ol className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {STEPS.map(([k, title, desc, to]) => (
          <li key={k} data-testid={`setup-step-${k}`}>
            <Link to={to} className={`flex items-start gap-2 border bg-white p-3 text-sm transition-colors hover:border-teal-400 ${st[k] ? "opacity-60" : ""}`}>
              {st[k] ? <CheckCircle weight="fill" className="mt-0.5 shrink-0 text-teal-600" size={18} /> : <Circle className="mt-0.5 shrink-0 text-slate-400" size={18} />}
              <span><span className={`font-semibold ${st[k] ? "line-through" : ""}`}>{title}</span><br /><span className="text-xs text-slate-500">{desc}</span></span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}
